import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { useSanityCta } from '~/composables/useSanityCta';
import { ISanityObjects, SanityObjectSchema } from '~/types/sanity-objects';


export default /*#__PURE__*/_defineComponent({
  __name: 'SanityCta',
  props: {
    urlOrReflink: null,
    ctaStyle: null
  },
  setup(__props: any) {

const props = __props as {
  urlOrReflink: ISanityObjects[SanityObjectSchema.URL_OR_REFLINK];
  ctaStyle: 'primary' | 'secondary';
}



const { href, isExternalLink, isLoading, target } = useSanityCta(
  props.urlOrReflink,
);

const classes = computed(() => ({
  'sanity-cta d-inline-flex text-decoration-none align-center justify-center rounded-pill font--button px-4 py-3':
    true,
  'g-background-accent white--text': props.ctaStyle === 'primary',
  'border-white white--text': props.ctaStyle === 'secondary',
}));

return { __sfc: true,props, href, isExternalLink, isLoading, target, classes }
}

})